<template>
  <Breadcrumbs
      title="Create Distributor Banks"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Distributor Banks', path: '/distributor-banks' },
      { label: 'Create Distributor Banks', path: '/new-banks' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <newBanks/>
    </div>
  </div>
</template>

<script>
import newBanks from './new_banks_form.vue'
export default {
  name: 'indexList',
  components: {
    newBanks,
  },
}
</script>